import {AppSidebar} from "@/components/Sidebar.tsx";
import FlashMessage from "@/components/FlashMessage.tsx";


const AppLayout:React.FC<{children: React.ReactNode}> = ({children}) => {
    return (
        <div className="flex h-screen bg-background text-foreground">
            <AppSidebar />
            <main className="flex-1 overflow-auto">
                <FlashMessage/>
                {children}
            </main>
        </div>
    );
};

export default AppLayout;
